import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../../services/api';

// Fallback social media links if API fails
const fallbackSocialLinks = [
  {
    name: 'Facebook',
    platform: 'facebook',
    url: 'https://www.facebook.com/',
    icon_class: 'fab fa-facebook-f'
  },
  {
    name: 'Twitter',
    platform: 'twitter', 
    url: 'https://www.twitter.com/',
    icon_class: 'fab fa-twitter'
  },
  {
    name: 'LinkedIn',
    platform: 'linkedin',
    url: 'https://www.linkedin.com/',
    icon_class: 'fab fa-linkedin-in'
  },
  {
    name: 'WhatsApp',
    platform: 'whatsapp',
    url: 'https://www.whatsapp.com/',
    icon_class: 'fab fa-whatsapp'
  },
  {
    name: 'Instagram',
    platform: 'instagram',
    url: 'https://instagram.com/',
    icon_class: 'fab fa-instagram'
  }
];

function SocialMediaLinks({ className = "th-social", loading: showLoading = false }) {
  const [socialLinks, setSocialLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const response = await apiService.getSocialMediaLinks();
        if (response && response.results && response.results.length > 0) {
          setSocialLinks(response.results);
        } else {
          // Use fallback data if no links from API
          setSocialLinks(fallbackSocialLinks);
        }
      } catch (error) {
        console.error('Error fetching social media links:', error);
        // Use fallback data on error
        setSocialLinks(fallbackSocialLinks);
      } finally {
        setLoading(false);
      }
    };

    fetchSocialLinks();
  }, []);

  if (loading && showLoading) {
    return (
      <div className={className}>
        <div className="spinner-border spinner-border-sm text-primary" role="status">
          <span className="visually-hidden">Loading social media links...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      {socialLinks.map((link, index) => {
        const linkUrl = link.url || '#';
        const iconClass = link.icon_class || 'fas fa-link';
        const linkName = link.name || `Social ${index + 1}`;
        const isExternalLink = linkUrl && linkUrl !== '#' && linkUrl.startsWith('http');
        
        return isExternalLink ? (
          <a 
            key={link.id || index}
            href={linkUrl}
            target="_blank" 
            rel="noopener noreferrer" 
            title={linkName}
            aria-label={linkName}
          >
            <i className={iconClass} />
          </a>
        ) : (
          <Link 
            key={link.id || index}
            to={linkUrl === '#' ? '#' : linkUrl} 
            title={linkName}
            aria-label={linkName}
          >
            <i className={iconClass} />
          </Link>
        );
      })}
    </div>
  );
}

export default SocialMediaLinks;
